<template>
  <div class="app-container">
    <div class="title red">中转仓须知</div>
    <div class="content">
      <li>1. 易碎品，水果件，易腐烂件，生鲜件，植物类包丢不包损。只承担丢件罚款，其他罚款，例如揽收超时产生的罚款不承担! </li>
      <li>2. 外包装完整但商品破损的物流是不给予赔付处理的，需商家自行承担损失。</li> 
      <li>3. 中转仓赔付标准：按采购金额赔付，最高赔付200元。</li>
      <li>4. 商品丢件一个月内找到取消理赔，没有找到每月20号理赔，丢件快递费和拆包费不理赔 </li> 
      <li>5. 体积较大产品，按计泡重量结算。记泡公式：长*款*高/8000计算重量，如：长宽高20cm*30cm*40cm/8000=4KG。体积重量大于实际重量按体积重量结算。实际重量大于体积重量按实际重量结算。</li>
      <li style="color: red;">6. 以下商品中转仓拒收：商品超过1.2米，重量大于50KG，易燃易爆，酒水饮料，生鲜冷冻，易腐烂品，绿植，加急产品，不给予发出，会做拒收处理</li>
      <li style="color: red;">7. 产生以下行为，将禁用账号或罚款，产生损失自行承担。</li>
      <ol style="color: red;">
        <li>（1）发快递违禁品：<a href="https://zwfw.spb.gov.cn/gjj/jxjwpml" target="_blank">https://zwfw.spb.gov.cn/gjj/jxjwpml</a>（快递抽查发现违禁品导致罚款的自行承担罚款）</li>
        <li>（2）恶意申请仅退款或耗上家羊毛导致上家投诉快递 </li>
        <li>（3）恶意投诉快递（任何问题优先联系客服协商处理）</li>
      </ol>
    </div>

    <div class="title">中转仓和单号规则</div>
    <div class="content">
      <li>1. 中转仓默认匹配发货地最近中转仓，如未匹配（请咨询上家客服发货地后，手动匹配最近仓库）</li>
      <li>2. 为保证发货时效，客户端可设置：23小时强制出单。出单后20-24小时自动揽收物流轨迹，防止平台48小时揽收超时发货</li>
      <li>3. 如出中转单号，并且虚拟揽收后。根据平台规则1仓 2仓 48小时内，3仓72小时内，上家包裹必须到仓中转发货。如未及时中转发货，此中转单号必须使用礼品包裹发货，并收取礼品费（3仓暂不收取礼品费，超时后会自动拦截此单号作废）。上家包裹额外取号发货</li>
    </div>

    <div class="title">中转仓扣费说明</div>
    <div class="content">
      <li>（1）下单成功后按0.5KG扣除首重费用（快递费+操作费0.29）。</li>
      <li>（2）到达中转仓称重发出后计算实际重量，扣除续重费用+拆包费0.3（<span class="red">1仓 2仓不勾选拆包不扣费。3仓强制拆包并收取拆包费</span>）。</li>
      <li>（3）下单成功后，中转仓未取号发货。可取消下单退还中转仓首重费用。</li>
      <li>（4）<span class="red">礼品费：按各仓库的收货地首重收费。减少礼品费方案:1.买家付数后及时采购 2.采购时优先选择当日可发货上家 3.根据上家发货地选择最近仓库中转</span></li>
    </div>

    <div class="title">中转仓使用流程</div>
    <div class="content">
      <div style="margin: 15px 0">
        第一步：云仓充值余额，<span style="color: red">确保余额充足。防止到仓后续重扣除，余额不足货物滞留无法发货</span><br />
        <span class="red" style="display: block; margin-top: 10px;">云仓余额使用说明：（1）客户端主账号和子账号，默认使用主账号云仓余额。（2）云仓主账号可管理，客户端子账号关联云仓子账号，关联后客户端子账号只能使用对应关联的云仓子账号余额</span>
      </div>
      <div style="margin: 15px 0">
        第二步：下载软件客户端（拍单发货售后在客户端操作，云仓仅充值余额即可）
      </div>
      <div style="margin: 15px 0">
        第三步：打开客户端采购，中转仓下单
      </div>
      <div style="margin: 15px 0">
        <img :src="order" width="100%" />
      </div>
      <div>
        <span class="red">
          注意：中转仓同步订单必须订购，服务市场应用或ERP才能密文下单，详情咨询客服
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  name: "jianjie",
  data() {
    return {
      activeIndex: 0,
      idx: 2,
      isShow: false,
      nbisShow: false,
      userName: "",
      user_balance: 0.0,
      userType: "",

      userToken: Cookies.get("view_userToken"),
      isLogin: true,
      cnyc_czjt_img: require("@/assets/cnyc_czjt.png"),
      ry_czjt_img: require("@/assets/ry_czjt.jpg"),
      order: require("@/assets/order.png"),
      isCnyc: true,
      isRyyc: false,
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    // const userToken = Cookies.get("view_userToken");
    // if (userToken == undefined) {
    //     this.isLogin = false;
    //   this.$confirm("请先登录再使用！", "提示", {
    //     confirmButtonText: "确定",
    //   })
    //     .then(() => {
    //       // 重新导航到登录页面
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/login" });
    //     })
    //     .catch(() => {
    //       // 重新导航到首页
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/" });
    //     });
    //   return;
    // } else {
    //   this.isLogin = true;
    // }
    const sn = Cookies.get("view_site_name");
    if (sn == "菜鸟云仓" || sn == "菜鸟云仓test") {
      this.isCnyc = true;
      this.isRyyc = false;
    } else if (sn == "如意云仓") {
      this.isRyyc = true;
      this.isCnyc = false;
    }
  },
  methods: {},
};
</script>

<style scoped>
.app-container {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
}
.red {
  color: red;
}
.title {
  font-size: 30px;
  text-align: center;
  margin: 20px 0px;
}
.content {
  margin-top: 10px;
  margin-bottom: 30px;
  font-size: 16px;
  margin: 0 auto;
  width: 80%;
}
li,ol {
  list-style-type: none;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/zzc/jianjie.vue